import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import type { FunctionComponent, RefObject } from 'react';
import Highlighter from 'react-highlight-words';

import type { SkillShort } from '~/shared/data-contract/skill';

export const Dropdown: FunctionComponent<{
    readonly activeId: string;
    readonly onSkillSelected: (skillId: SkillShort) => void;
    readonly positionRef: RefObject<HTMLElement | null>;
    readonly searchTerm: string;
    readonly skills: readonly SkillShort[];
}> = ({ activeId, onSkillSelected, positionRef, searchTerm, skills }) => {
    const width = positionRef.current?.getBoundingClientRect().width ?? 0;

    return (
        <Popper
            anchorEl={positionRef.current}
            id="search-dropdown"
            open={true}
            placement="bottom"
            sx={{
                borderRadius: '0 0 8px 8px',
                boxShadow: 1,
                overflow: 'hidden',
                width,
                zIndex: 2000,
            }}
        >
            <Paper>
                <MenuList sx={{ maxHeight: '600px', maxWidth: '100%', overflowY: 'scroll', pb: 0, pt: 0 }}>
                    {skills.map((skill) => (
                        <MenuItem
                            key={skill.id}
                            selected={skill.id === activeId}
                            onClick={() => onSkillSelected(skill)}
                        >
                            <Highlighter
                                autoEscape={true}
                                highlightTag="strong"
                                searchWords={[searchTerm]}
                                style={{ overflowX: 'hidden', textOverflow: 'ellipsis' }}
                                textToHighlight={skill.title}
                            />
                        </MenuItem>
                    ))}
                </MenuList>
            </Paper>
        </Popper>
    );
};
